import {
    VERYF_LOADING,
    VERYF_LOADED,
    VERYF_ERROR,

    RECUPERAR_LOADING,
    RECUPERAR_LOADED,
    RECUPERAR_ERROR
  } from './../../types/verificacion';

const INITIAL_STATE = {
    isLoading: false,
    user_v: null,
    error: '',
    recuperar: null,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case VERYF_LOADING:
            return {
                ...state,
                isLoading: true,
                user_v: null,
                recuperar:null,
                error: '',
            };
        case VERYF_LOADED:
            localStorage.removeItem('token');
            localStorage.setItem('token', action.payload.token);
            return { 
                ...state, 
                isLoading: false,
                user_v: action.payload,
                recuperar:null,
                error: '',
                }
        case VERYF_ERROR:
            return {
                ...state,
                isLoading: false,
                user_v: null,
                recuperar:null,
                error: action.payload,
            }


        case RECUPERAR_LOADING:
            return {
                ...state,
                isLoading: true,
                user_v: null,
                recuperar:null,
                error: '',
            };
        case RECUPERAR_LOADED:
            return { 
                ...state, 
                isLoading: false,
                user_v: null,
                recuperar: action.payload,
                error: '',
                }
        case RECUPERAR_ERROR:
            return {
                ...state,
                isLoading: false,
                user_v: null,
                recuperar: null,
                error: action.payload,
            }
        default: return state;
    }
}